import { PLUGIN_OPERATIONS, DIRECT_PLUGIN } from '@openedx/frontend-plugin-framework';
import { DatadogLoggingService } from '@edx/frontend-logging';
import NotificationsTray from '@edx/frontend-plugin-notifications';

const config = {
  loggingService: DatadogLoggingService,
  pluginSlots: {
    notifications_tray: {
      plugins: [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'notification_tray',
            type: DIRECT_PLUGIN,
            RenderWidget: NotificationsTray,
          },
        }
      ]
    }
  }
};

export default config;
